module.exports = __webpack_public_path__ + "static/media/hkws_banner@2x.f129da5b.png";